import { RootState } from "@redux/app/store"
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export type ConsumptionMapFiltersFacilities = {
	facilities: {
		showPorts: boolean
		showFishFarms: boolean
		showPlatforms: boolean
		showDischargeTerminals: boolean
		showDischargeSTS: boolean
		showAnchorage: boolean
		showWindTurbines: boolean
	}
}

export const defaultState: ConsumptionMapFiltersFacilities = {
	facilities: {
		showPorts: false,
		showFishFarms: false,
		showPlatforms: false,
		showDischargeTerminals: false,
		showDischargeSTS: false,
		showAnchorage: false,
		showWindTurbines: false,
	},
}

const storedState = localStorage.getItem("consumptionMapFiltersFacilities")
export const initialState: ConsumptionMapFiltersFacilities =
	storedState !== null ? JSON.parse(storedState) : defaultState

const consumptionMapFiltersFacilitiesSlice = createSlice({
	name: "consumptionMapFiltersFacilities",
	initialState,
	reducers: {
		updateConsumptionMapFiltersFacilities(
			state,
			action: PayloadAction<ConsumptionMapFiltersFacilities>
		) {
			localStorage.setItem("consumptionMapFiltersFacilities", JSON.stringify(action.payload))
			return { ...state, ...action.payload }
		},
		resetConsumptionMapFiltersFacilities(state) {
			localStorage.setItem("consumptionMapFiltersFacilities", JSON.stringify(defaultState))
			return { ...state, ...defaultState }
		},
	},
})

export const { updateConsumptionMapFiltersFacilities, resetConsumptionMapFiltersFacilities } =
	consumptionMapFiltersFacilitiesSlice.actions

export const getConsumptionMapFiltersFacilities = (state: RootState) =>
	state.consumptionMapFiltersFacilities
export default consumptionMapFiltersFacilitiesSlice.reducer
